import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

export class Interceptor implements HttpInterceptor{
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.search('/login') === -1) {
      if (localStorage.getItem('cealm-token') !== null) {
        const tokenCEALM = atob(localStorage.getItem('cealm-token'));
        const customReq = req.clone({
          headers: new HttpHeaders().set('Authorization', tokenCEALM)
        });
        return next.handle(customReq);
      } else {
        return next.handle(req);
      }
    } else {
      return  next.handle(req);
    }
  }
}
